import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getData } from './actions'
import BlockUi from 'react-block-ui';
const constUrl = {
  urlDonHang : "/order-report",
  urlDoanhSo : "/sale-report",
  urlGiaoDich : "/guest-report",
  urlDoPhu : "/sale-total-report",
}
class Stats extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    var requestData = {
      tu_ngay: this.props.tu_ngay,
      den_ngay: this.props.den_ngay,
      store_id: this.props.store_id,
    }
    this.props.getData(requestData)
  }
  onStatsClick = (url) => {
    if (url && url != '') {
      this.props.history.push(url)
    }
  }
  render() {
    const {
      requesting,
      data
    } = this.props
    return (
      <BlockUi tag="div" blocking={requesting} className="w-100">
        <Fragment>
          <div className="col-sm-6 col-md-3 pull-left" onClick={() => this.onStatsClick(constUrl.urlDonHang)}>
            <div className="text-white bg-info card">
              <div className="card-body" style={{ padding: 10, cursor: "pointer" }}>
                <div className="h1 text-white text-right mb-2"><i className="icon-basket-loaded"></i></div>
                <div className="h4 mb-0">{parseFloat(data.donHangThang || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</div>
                <small className="text-uppercase font-weight-bold text-white">Đơn hàng trong tháng</small>
                <div className="progress-xs mt-3 mb-0 progress-white progress">
                  <div className="progress-bar" role="progressbar" style={{ width: "40%" }}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-3 pull-left" onClick={() => this.onStatsClick(constUrl.urlDoanhSo)}>
            <div className="text-white bg-success card">
              <div className="card-body" style={{ padding: 10, cursor: "pointer" }}>
                <div className="h1 text-white text-right mb-2"><i className="fa fa-cogs"></i></div>
                <div className="h4 mb-0">{parseFloat(data.doanhSoThang || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</div>
                <small className="text-white text-uppercase font-weight-bold">Doanh số trong tháng</small>
                <div className="progress-xs mt-3 mb-0 progress-white progress">
                  <div className="progress-bar" role="progressbar" style={{ width: "50%" }}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-3 pull-left" onClick={() => this.onStatsClick(constUrl.urlGiaoDich)}>
            <div className="text-white bg-primary card">
              <div className="card-body" style={{ padding: 10, cursor: "pointer" }}>
                <div className="h1 text-white text-right mb-2"><i className="icon-pie-chart"></i></div>
                <div className="h4 mb-0">
                  {parseFloat(data.khachGiaoDichThang || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                  /{parseFloat(data.tongKhach || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                </div>
                <small className="text-white text-uppercase font-weight-bold">Khách hàng giao dịch</small>
                <div className="progress-xs mt-3 mb-0 progress-white progress">
                  <div className="progress-bar" role="progressbar" style={{ width: "60%" }}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-3 pull-left" onClick={() => this.onStatsClick(constUrl.urlDoPhu)}>
            <div className="text-white bg-danger card">
              <div className="card-body" style={{ padding: 10, cursor: "pointer" }}>
                <div className="h1 text-white text-right mb-2"><i className="icon-speedometer"></i></div>
                <div className="h4 mb-0">
                  {parseFloat(data.doPhuNganhThang || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                  /{parseFloat(data.tongPhuNganh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                </div>
                <small className="text-white text-uppercase font-weight-bold">Độ phủ ngành hàng</small>
                <div className="progress-xs mt-3 mb-0 progress-white progress">
                  <div className="progress-bar" role="progressbar" style={{ width: "70%" }}></div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </BlockUi>
    )
  }
}
const mapStateToProps = state => ({
  data: state.stats.data || [],
  requesting: state.stats.requesting,
  successful: state.stats.successful,
});

const connected = connect(
  mapStateToProps,
  {
    getData: getData
  }
)(Stats);

export default connected


// WEBPACK FOOTER //
// ./src/components/Stats/Stats.js